<template>
  <VCard :style="defaultStyle" class="default outline" :radius="30" :color="ColorType.none">
    <VBlock class="wrapper" :direction="Direction.row" :sort="Sort.center_center">
      <VStockButton
        class="minus"
        :type="StockButtonType.minus"
        :clickEvent="onSubEvent"
        :inactive="minValidate"
      />
      <span class="quantity">{{ isSet ? `${quantity}세트` : quantity}}</span>
      <VBlock class="counting-anim-wrapper" v-for="(anim, idx) in quantityAnim.array" :key="idx">
        <QuantityAnimation :active="anim.active" />
      </VBlock>
      <VStockButton
        class="plus"
        :type="StockButtonType.plus"
        :clickEvent="addQuantityEvent"
        :inactive="maxValidate"
      />
    </VBlock>
  </VCard>
</template>

<script>
import VP from '@/presentationals/v2/components/layouts/atoms/VP'
import VSpan, { TextColor } from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VStockButton, {
  StockButtonType
} from '@/presentationals/v2/components/layouts/atoms/VStockButton'

import VCard, { ColorType } from '@/presentationals/v2/components/layouts/molecules/VCard'
import VBlock, { Direction, Sort } from '@/presentationals/v2/components/layouts/molecules/VBlock'

import QuantityAnimation from './QuantityAnimation'

export default {
  name: 'QuantityCalculator',
  props: {
    isSet: {
      type: Boolean,
      default: false
    },
    quantity: {
      type: Number,
      required: true
    },
    stockCount: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    onAddEvent: {
      type: Function,
      required: true
    },
    onSubEvent: {
      type: Function,
      required: true
    }
  },
  components: {
    VStockButton,
    VP,
    VSpan,
    VCard,
    VBlock,
    QuantityAnimation
  },
  methods: {
    async addQuantityEvent() {
      await this.onAddEvent()
      if (this.quantity >= this.max) return
      if (this.quantity >= this.stockCount) return

      this.quantityAnim.array[this.quantityAnim.count].active = true
      setTimeout(() => {
        this.quantityAnim.array[this.quantityAnim.count].active = false
      }, 500)

      this.quantityAnim.count += 1
      if (this.quantityAnim.count >= this.quantityAnim.array.length - 1) this.quantityAnim.count = 0
    }
  },
  computed: {
    minValidate() {
      return this.min >= this.quantity
    },
    maxValidate() {
      if (this.stockCount <= this.quantity) return true

      return this.max <= this.quantity
    },
    defaultStyle() {
      return this.isSet
        ? { width: '129px', height: '38px' }
        : {
            width: '100px',
            height: '36px'
          }
    }
  },
  data() {
    return {
      ColorType,
      Direction,
      Sort,
      StockButtonType,
      TextColor,

      quantityAnim: {
        array: [
          { active: false },
          { active: false },
          { active: false },
          { active: false },
          { active: false },
          { active: false },
          { active: false },
          { active: false },
          { active: false },
          { active: false },
          { active: false },
          { active: false },
          { active: false },
          { active: false },
          { active: false }
        ],
        count: 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.default {
  position: relative;
  z-index: 1;

  .wrapper {
    height: 100%;
    align-items: center;
    position: relative;

    .minus,
    .plus {
      width: 33%;
      height: 30px;
    }

    .counting-anim-wrapper {
      position: absolute;
      top: 0;
      left: 0;
    }

    .quantity {
      width: 34%;
      display: inline-block;
      font-size: 16px;
      text-align: center;
      vertical-align: top;
      padding-top: 2px;
    }
  }
}

.outline {
  border: 1px solid $light-gray-4;
}
</style>